//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../Diagramming/Diagramming.SheetElementBuilder.js";
let d=[[[0,"Direction",1,0],[0,"NumberAllowedConnections",1,0],[0,"Pinned",1,0],[0,"Proxy",1,"Diagramming.Port",0]],[[["isAllowedLeftSide","isAllowedRightSide","isAllowedUpSide","isAllowedDownSide"],"GetAllowedParentSides",{},0,0],[[],"CanAnotherConnectionBeAdded",{R_:{canAnotherConnectionBeAdded:''}},0,0],[[],"IsNumberOfConnectionInfinite",{R_:{isNumberOfConnectionInfinite:''}},0,0],[[],"GetOwningConnectableElement",{R_:{owner:"Diagramming.ConnectableElement"}},0,0],[["numConnections"],"GetConnections",{R_:{connections:"Diagramming.Connection[]"}},0,0]],[]];
SPLM.Diagramming.PortBuilder = class extends SPLM.Diagramming.SheetElementBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.PortBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;